import React, { useState, useEffect, useContext } from 'react';
import { BrainButton, BuilderContainer, HighLevelContainer } from './CrewBuilderElements';
import SlateDisplay from '../SlateDisplayForms/SlateDisplay';
import PlayerOptionList from '../PlayerDisplayForms/PlayerOptionList';
import TeamDisplay from '../TeamDisplayForms/TeamViewer';
import GetTeams from '../CashCrewForms/GetTeams';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { post } from 'aws-amplify/api';
import SlateHeader from './SlateHeader';
import { AccountContext } from '../Accounts'
import { useNavigate } from 'react-router-dom'
import UserProjectionDisplay from './UserProjectionDisplay';
import GetTimeframe from './GetTimeframe';
import GetAssets from './GetAssets';
import SavedHeader from './SavedTeamsHeader';
import GetPublicResource from './GetPublicResource';
import { FaBrain } from 'react-icons/fa';
import RightSlideModal, { AgenticOverlay } from '../AgenticModalForms';
import PostRequest from './postAPIRequest';
import CaptainTeamDisplay from '../TeamDisplayForms/CaptainTeamViewer';
import CaptainTeamTable from '../CaptainTeamTable/index.js';
import ClassicTeamTable from '../ClassicTeamTable/index.js';

const AssetViewer = ({ }) => {

    const [status, setStatus] = useState(false)
    const [slate, setSlate] = useState();
    const [teams, setTeams] = useState([]);
    const [assets, setAssets] = useState([]);
    const [modTeam, setModTeam] = useState({ assetList: [] });
    const [original, setOriginal] = useState([]);
    const [teamStatus, setTeamStatus] = useState(false);
    const [listStatus, setListStatus] = useState(false);
    const [modalMessage, setModalMessage] = useState('Modification Error');
    const [loadingBoolean, setLoadingBoolean] = useState(false);
    const [teamCost, setTeamCost] = useState(50001);
    const [timeframe, setTimeframe] = useState('');
    const [timeframeStatus, setTimeframeStatus] = useState(false);
    const [hidden, setHidden] = useState(true);
    const [currentCard, setCurrentCard] = useState(0);
    const [savedList, setSavedList] = useState([]);
    const [savedTeams, setSavedTeams] = useState([]);
    const [submitStatus, setSubmitStatus] = useState(false);
    const [token, setToken] = useState("");
    const [aiOverlay, setAIOverlay] = useState(false);
    const [playerModal, setPlayerModal] = useState(false);
    const [fillPosition, setFillPosition] = useState('');

    const { getSession } = useContext(AccountContext);

    const navigate = useNavigate();

    useEffect(() => {
        getSession()
            .then(session => {
                // console.log(session.tokens?.idToken?.toString());
                setStatus(true);
                // setToken(session.getIdToken().getJwtToken());
            })
            .catch(err => {
                console.log(err);
                navigate('/signin')
            })
    });

    // useEffect(() => {
    //     Amplify.configure({
    //         Auth: {
    //             identityPoolId: 'us-east-1:0db79a0a-0f8a-4b4e-b40a-a391a825b362', //REQUIRED - Amazon Cognito Identity Pool ID
    //             region: 'us-east-1', // REQUIRED - Amazon Cognito Region
    //             userPoolId: 'us-east-1_Je7d8Vt7C', //OPTIONAL - Amazon Cognito User Pool ID
    //             userPoolWebClientId: '3uvt4462pobut6jo1f8orirhro', //OPTIONAL - Amazon Cognito Web Client ID
    //         },
    //         Storage: {
    //             AWSS3: {
    //                 bucket: 'cashcrewio90a6c86a16094e0486e4ed2e883587bf60607-dev', //REQUIRED -  Amazon S3 bucket name
    //                 region: 'us-east-1', //OPTIONAL -  Amazon service region
    //             }
    //         }
    //     });
    // })

    useEffect(() => {
        if (status) {
            const timeframeInWait = async () => {
                const tfInWait = await GetPublicResource('timeframe.json').then(timeframe => timeframe)
                setTimeframe(tfInWait);
                // console.log(timeframe)
                setTimeframeStatus(true)
            }
            timeframeInWait()
                .catch(console.error());;
        }
    }, [status]);

    useEffect(() => {
        if (slate) {
            const teamsWait = async () => {
                const slateTeams = timeframe.ApiSeason + "/" + timeframe.ApiWeek + "/" + slate.SlateID + "_teams.json"
                // console.log(slate)
                // console.log(slateTeams)
                const teamsInWait = await GetPublicResource(slateTeams).then(teams => teams)
                setTeams(teamsInWait);
                setListStatus(true);
            }
            teamsWait()
                .catch(console.error());;
        }
    }, [slate]);

    useEffect(() => {
        if (slate) {
            const projectionPlayersInWait = async () => {
                const assetPath = timeframe.ApiSeason + "/" + timeframe.ApiWeek + "/" + slate.SlateID + "_assets.json"
                const playersInWait = await GetPublicResource(assetPath).then(assets => assets)
                setAssets(playersInWait);
            }
            projectionPlayersInWait()
                .catch(console.error());;
        }
    }, [slate]);


    const checkConstraints = (input) => {
        if (slate.OperatorGameType === "Showdown Captain Mode") {
            const numberOfCaptain = modTeam.assetList.filter((p, ind) => p.position === 'CPT').length
            const numberOfFlex = modTeam.assetList.filter((p, ind) => p.position === 'FLEX').length
            const numberOfPlayers = modTeam.assetList.length
            const teamSet = modTeam.assetList.filter((p, ind) => p.name === input.name)
            const currentCost = modTeam.assetList.reduce((total, currentValue) => total = total + currentValue.currentCost, 0)
            const totalCost = currentCost + input.currentSalary
            const isNotUnique = teamSet.length > 0
            if (numberOfPlayers > 6) {
                setModalMessage('Invalid Add: Too many players');
                return false
            }
            else {
                if (totalCost > 50000) {
                    setModalMessage('Invalid Add: Salary exceeds team budget');
                    return false
                }
                else {
                    if (isNotUnique) {
                        setModalMessage('Invalid Add: Already on team');
                        return false
                    }
                    else {
                        if (input.position === 'CPT' & numberOfCaptain > 0) {
                            setModalMessage('Invalid Add: Two captains remove captain before adding');
                            return false
                        }
                        else {
                            console.log(numberOfFlex)
                            if (input.position === 'FLEX' & numberOfFlex > 4) {
                                setModalMessage('Invalid Add: Too many flex players remove flex player before adding')
                                return false
                            }
                            else {
                                return true
                            }
                        }
                    }
                }
            }
        }
        else {
            const numberOfWR = modTeam.assetList.filter((p, ind) => p.position === 'WR').length
            const numberOfRB = modTeam.assetList.filter((p, ind) => p.position === 'RB').length
            const numberOfTE = modTeam.assetList.filter((p, ind) => p.position === 'TE').length
            const numberOfQB = modTeam.assetList.filter((p, ind) => p.position === 'QB').length
            const numberOfDST = modTeam.assetList.filter((p, ind) => p.position === 'DST').length
            const numberOfFlex = numberOfRB + numberOfWR + numberOfTE
            const numberOfPlayers = modTeam.assetList.length
            const teamSet = modTeam.assetList.filter((p, ind) => p.name === input.name)
            const currentCost = modTeam.assetList.reduce((total, currentValue) => total = total + currentValue.currentCost, 0)
            const totalCost = currentCost + input.currentSalary
            // console.log(totalCost)
            const isNotUnique = teamSet.length > 0
            const flexExists = numberOfRB === 3 || numberOfWR === 4 || numberOfTE === 2

            if (numberOfPlayers > 9) {
                setModalMessage('Invalid Add: Too many players');
                return false
            }
            else {
                if (totalCost > 50000) {
                    setModalMessage('Invalid Add: Salary exceeds team budget');
                    return false
                }
                else {
                    if (isNotUnique) {
                        setModalMessage('Invalid Add: Already on team');
                        return false
                    }
                    else {
                        if (input.position === 'QB' & numberOfQB > 0) {
                            setModalMessage('Invalid Add: Two quarterbacks remove quarterback before adding');
                            return false
                        }
                        else {
                            if (input.position === 'DST' & numberOfDST > 0) {
                                setModalMessage('Invalid Add: Two defenses remove defense before adding')
                                return false
                            }
                            else {
                                if (numberOfFlex > 7) {
                                    setModalMessage('Invalid Add: Too many flex eligible players');
                                    return false
                                }
                                else {
                                    if (input.position === 'TE' & numberOfTE > 0 & flexExists) {
                                        setModalMessage('Invalid Add: Too many Tight Ends remove TE or Flex before adding');
                                        return false
                                    }
                                    else {
                                        if (input.position === 'RB' & numberOfRB > 1 & flexExists) {
                                            setModalMessage('Invalid Add: Too many Running Backs remove Running Back or Flex before adding');
                                            return false
                                        }
                                        else {
                                            if (input.position === 'WR' & numberOfWR > 2 & flexExists) {
                                                setModalMessage('Invalid Add: Too many Wide Receivers remove Wide Receiver or Flex before adding');
                                                return false
                                            }
                                            else {
                                                return (true)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    const optimize = (inputs) => e => {
        e.preventDefault();
        setLoadingBoolean(true);
        if (inputs.assetList.length >= 8) {
            console.log("too many players for re-opt")
            // console.log(inputs)
            setLoadingBoolean(false);
            toast.error("Too Many Players For Optimization", {
                position: "bottom-right",
                theme: 'dark',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });;
        }
        else {
            setLoadingBoolean(true);
            const data = inputs.assetList.map((p, ind) => p.name);
            const request = {
                'season': timeframe.ApiSeason,
                'week': timeframe.ApiWeek,
                'slateID': slate.SlateID,
                'chosen': data
            }
            // console.log(request)
            try {
                const callOptimize = async () => {
                    // const response = await post({
                    //     apiName: 'cashcrewchosen',
                    //     path: '/',
                    //     options: {
                    //         headers: {
                    //             Authorization: `Bearer ${token}`,
                    //         },
                    //         body: request,
                    //     },
                    // }).response;

                    // const data = await response.body.json();
                    const data = await PostRequest(request);

                    setModTeam({ assetList: handleOptimizedTeam(data.assetList) });
                    setTeamCost(
                        data.assetList.reduce((total, currentValue) => total + currentValue.currentCost, 0)
                    );
                    setLoadingBoolean(false);
                }
                callOptimize();
            } catch (error) {
                console.error('API call failed:', error);
                setLoadingBoolean(false);
            }
        }
    }

    const handleAdd = (input) => e => {
        const check = checkConstraints(input)
        // console.log(check)
        if (check) {
            if (input.position === 'DST') {
                const newAdd = {
                    name: input.name,
                    team: input.team,
                    position: input.position,
                    currentCost: input.currentSalary,
                    dkPoints: input.ifDefenseProjectedStats.FantasyPointsDraftKings
                };
                const newList = modTeam.assetList.push(newAdd)
                setModTeam({ assetList: modTeam.assetList })
                setTeamCost(modTeam.assetList.reduce((total, currentValue) => total = total + currentValue.currentCost, 0))
            }
            else {
                const newAdd = {
                    name: input.name,
                    team: input.team,
                    position: input.position,
                    currentCost: input.currentSalary,
                    dkPoints: input.projectedStats.FantasyPointsDraftKings
                };
                const newList = modTeam.assetList.push(newAdd)
                setModTeam({ assetList: modTeam.assetList })
                setTeamCost(modTeam.assetList.reduce((total, currentValue) => total = total + currentValue.currentCost, 0))
            }
            toast.success("Successfull Add", {
                position: "bottom-right",
                theme: 'dark',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });;
            setPlayerModal(false);
        }
        else {
            console.log(modalMessage);
            toast.error(modalMessage, {
                position: "bottom-right",
                theme: 'dark',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });;
        }
    }

    const handleRemove = (input) => e => {
        if (teamStatus) {
            setModTeam({ assetList: modTeam.assetList.filter(player => player !== input) })
            setTeamCost(modTeam.assetList.filter(player => player !== input).reduce((total, currentValue) => total = total + currentValue.currentCost, 0))
            // console.log(teamCost)
            // console.log('here')
        }
        else {
            setModTeam({ assetList: teams[0].assetList.filter(player => player !== input) })
            setTeamCost(teams[0].assetList.filter(player => player !== input).reduce((total, currentValue) => total = total + currentValue.currentCost, 0))
            setOriginal(teams[0])
            // console.log(teamCost)
            setTeamStatus(true)
        }
        // console.log(input);
    }

    const handleReset = (e) => {
        e.preventDefault()
        if (teamStatus) {
            setModTeam({ assetList: original.assetList })
            setTeamCost(original.assetList.reduce((total, currentValue) => total = total + currentValue.currentCost, 0))
        }
    }

    const handleSlateSelect = (slate) => e => {
        setSlate(slate);
    }

    const handleSlateReset = () => e => {
        console.log("reset initiated");
        setListStatus(false);
        setCurrentCard(0);
        setHidden(true)
        setSubmitStatus(false);
        setSlate();
    }

    const handleNextProjection = (projection, player) => {
        const p = projection
        if (player.projectedStats) {
            player.projectedStats.FantasyPointsDraftKings = parseFloat(p)
        }
        else {
            if (player.ifDefenseProjectedStats) {
                player.ifDefenseProjectedStats.FantasyPointsDraftKings = parseFloat(p)
            }
            else {

            }
        }
        // console.log(p)
        // console.log(player)
        // console.log(savedList)
        const newList = savedList.filter(x => x.playerID != player.playerID).concat(player)
        setSavedList(newList)
        setCurrentCard(currentCard + 1)
        if (currentCard == 0) {
            setHidden(false)
        }
    }

    const handlePreviousProjection = (player) => {
        // console.log(savedList)
        const newList = savedList.filter(x => x.playerID != player.playerID)
        // console.log(newList)
        setSavedList(newList)
        // savedList.length > 0 ? setSavedList(savedList.filter(x => x.playerID != player.playerID)) : setSavedList([])
        setCurrentCard(currentCard - 1)
    }

    const handleProjectionSubmit = () => {
        const oldTeam = teams[0].assetList;

        // Create comparable objects for matching
        const oldTeamKeys = oldTeam.map(x => ({
            name: x.name,
            pos: x.position
        }));

        const newProjectionKeys = savedList.map(x => ({
            name: x.name,
            pos: x.position
        }));

        // Helper to check if a player exists in a list by name + pos
        const matchByNamePos = (list, item) =>
            list.some(y => y.name === item.name && y.pos === item.position);

        // Items in old team NOT in new projections
        const nonOverlap = oldTeam.filter(x =>
            !matchByNamePos(newProjectionKeys, x)
        );

        // Items in new projections that DO match old team
        const overlapNew = savedList.filter(x =>
            matchByNamePos(oldTeamKeys, x)
        );

        // Add updated projection values
        overlapNew.forEach(x => {
            const newAdd = {
                name: x.name,
                team: x.team,
                position: x.position,
                currentCost: x.currentSalary,
                dkPoints: x.projectedStats
                    ? x.projectedStats.FantasyPointsDraftKings
                    : x.ifDefenseProjectedStats.FantasyPointsDraftKings
            };

            nonOverlap.push(newAdd);
        });

        setSubmitStatus(true);
        setModTeam({ assetList: nonOverlap });
        setOriginal({ assetList: nonOverlap });
        setTeamStatus(true);
    };


    const handleOptimizedTeam = (team) => {
        const oldTeamNames = team.map(x => x.name)
        // console.log(oldTeamNames)
        const newProjectionNames = savedList.map(x => x.name)
        // console.log(newProjectionNames)
        const nonOverlap = team.filter(x => !newProjectionNames.includes(x.name))
        const overlapNew = savedList.filter(x => oldTeamNames.includes(x.name))
        // console.log(nonOverlap)
        // console.log(overlapNew)
        overlapNew.map(x => {
            if (x.projectedStats) {
                const newAdd = {
                    name: x.name,
                    team: x.team,
                    position: x.position,
                    currentCost: x.currentSalary,
                    dkPoints: x.projectedStats.FantasyPointsDraftKings
                };
                nonOverlap.push(newAdd)
            }
            else {
                const newAdd = {
                    name: x.name,
                    team: x.team,
                    position: x.position,
                    currentCost: x.currentSalary,
                    dkPoints: x.ifDefenseProjectedStats.FantasyPointsDraftKings
                };
                nonOverlap.push(newAdd)
            }
        })
        return nonOverlap
    }

    const handleSaveTeam = () => e => {
        e.preventDefault()
        if (modTeam.assetList.length == 9) {
            const qb = modTeam.assetList.filter(x => x.position == "QB").sort((a, b) =>
                a.name > b.name ? -1 : 1,
            )
            const rb = modTeam.assetList.filter(x => x.position == "RB").sort((a, b) =>
                a.name > b.name ? -1 : 1,
            )
            const wr = modTeam.assetList.filter(x => x.position == "WR").sort((a, b) =>
                a.name > b.name ? -1 : 1,
            )
            const te = modTeam.assetList.filter(x => x.position == "TE").sort((a, b) =>
                a.name > b.name ? -1 : 1,
            )
            const d = modTeam.assetList.filter(x => x.position == "DST" || x.position == "DEF").sort((a, b) =>
                a.name > b.name ? -1 : 1,
            )
            const assetList = qb.concat(rb).concat(wr).concat(te).concat(d)
            const team = { assetList: assetList }

            if (savedTeams.some(v => JSON.stringify(v.assetList.map(y => y.name)) == JSON.stringify(team.assetList.map(z => z.name)))) {
                toast.error("Team Already Saved", {
                    position: "bottom-right",
                    theme: 'dark',
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                });;
            }
            else {
                setSavedTeams(savedTeams.concat(team))
                console.log("Updated Saved Teams")
                // console.log(savedTeams)
            }
        }

    }

    useEffect(() => { if (listStatus == false) { setTeamStatus(false) } }, [listStatus])

    const handleOpenModal = (e) => {
        e.preventDefault();
        setAIOverlay(!aiOverlay);
    }

    const handleFill = (e, position) => {
        e.preventDefault();
        setPlayerModal(!playerModal);
        setFillPosition(position);
    }

    return (
        <div>
            {status ? (
                <HighLevelContainer>
                    <>
                        <BrainButton onClick={handleOpenModal} aria-label="Toggle modal">
                            <FaBrain />
                        </BrainButton>
                        {
                            listStatus ? (
                                submitStatus ? (
                                    <>
                                        <SlateHeader slate={slate} handleSlateReset={handleSlateReset} />
                                        {savedTeams.length > 0 && <SavedHeader teams={savedTeams} />}
                                        {/* <UserProjectionDisplay assetList={assets} handleNext={handleNextProjection} handlePrevious={handlePreviousProjection} hidden={hidden} currentCard={currentCard}/> */}
                                        <BuilderContainer>
                                            <ToastContainer />
                                            {slate.OperatorGameType === "Showdown Captain Mode" && <CaptainTeamTable team={modTeam} listStatus={listStatus} handleRemove={handleRemove} handleReset={handleReset} handleOptimize={optimize} loadingBoolean={loadingBoolean} handleSaveTeam={handleSaveTeam} handleFill={handleFill} />}
                                            {slate.OperatorGameType != "Showdown Captain Mode" && <ClassicTeamTable team={modTeam} listStatus={listStatus} handleRemove={handleRemove} handleReset={handleReset} handleOptimize={optimize} loadingBoolean={loadingBoolean} handleSaveTeam={handleSaveTeam} handleFill={handleFill} />}
                                        </BuilderContainer>
                                        {
                                            fillPosition && (<PlayerOptionList isOpen={playerModal} handleAdd={handleAdd} currentTeamCost={teamCost} listStatus={listStatus} playersList={assets} fillPosition={fillPosition} handleClose={() => setPlayerModal(false)} captainMode={slate.OperatorGameType === "Showdown Captain Mode"} />)
                                        }
                                        {/*<PlayerOptionList handleAdd={handleAdd} currentTeamCost={teamCost} listStatus={listStatus} playersList={assets} /> */}
                                    </>
                                ) :
                                    <div>
                                        <SlateHeader slate={slate} handleSlateReset={handleSlateReset} />
                                        <UserProjectionDisplay assetList={assets} handleNext={handleNextProjection} handlePrevious={handlePreviousProjection} handleSubmit={handleProjectionSubmit} hidden={hidden} currentCard={currentCard} />
                                        {/* <BuilderContainer>
                                    <ToastContainer />
                                    <TeamDisplay team={teams[0]} listStatus={listStatus} handleRemove={handleRemove} handleReset={handleReset} handleOptimize={optimize} loadingBoolean={loadingBoolean} />
                                    <PlayerOptionList handleAdd={handleAdd} currentTeamCost={teamCost} />
                                </BuilderContainer> */}
                                    </div>
                            ) :
                                <HighLevelContainer>
                                    {
                                        timeframeStatus ? (
                                            <SlateDisplay timeframe={timeframe} handleSlateSelect={handleSlateSelect} />
                                        ) :
                                            <></>
                                    }
                                </HighLevelContainer>
                        }
                        {
                            aiOverlay && (<AgenticOverlay isOpen={aiOverlay} onClose={(e) => handleOpenModal}>
                                <h2>Cash Crew Intelligence</h2>
                                <p>Optimize your DFS lineup with Crew Builder and smart insights.</p>
                            </AgenticOverlay>)
                        }
                    </>
                </HighLevelContainer>
            ) :
                <></>
            }
        </div>
    )
};

export default AssetViewer;